import { useEffect, useState } from 'react';
import { parkingQueueApi, SpotTarget } from '../../api/parkingQueueApi';
import { ParkingQueueEntry } from '../../types/parkingQueue';

/**
 * The entries standing ahead of `entryKey` for the spot (the deviation check),
 * rerun whenever the entry or spot changes. `null` while loading or without a
 * complete target. `exceptLeaseKey`: see `parkingQueueApi.deviationFor`.
 */
export const useQueueDeviation = (entryKey: string | null, target: Partial<SpotTarget>, exceptLeaseKey?: string): ParkingQueueEntry[] | null => {
    const [ahead, setAhead] = useState<ParkingQueueEntry[] | null>(null);
    const { buildingKey, areaKey, spotKey } = target;

    useEffect(() => {
        setAhead(null);
        if (!entryKey || !buildingKey || !areaKey || !spotKey) return;
        let cancelled = false;
        parkingQueueApi.deviationFor(entryKey, { buildingKey, areaKey, spotKey }, exceptLeaseKey)
            .then(a => { if (!cancelled) setAhead(a); })
            .catch(e => { console.error(e); if (!cancelled) setAhead([]); });
        return () => { cancelled = true; };
    }, [entryKey, buildingKey, areaKey, spotKey, exceptLeaseKey]);

    return ahead;
};
